var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signUp"}},[_c('appHeader',{attrs:{"title":'員工登入'}}),_c('router-view',{staticClass:"content-body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }